
import React from 'react'
import { Tabs, Button, Pagination, message } from 'antd';
import Config from "../../config/Config";
import WidgetAjax from '../../widget/WidgetAjax';
import { UserOutlined } from '@ant-design/icons';
import Table from './com/table';
let path = Config.getBasePath();
let filePath = Config.getFilePath();

class feedback extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tabsData: [
        // { key: '1', label: '已查看' },
        // { key: '2', label: '邀请面试' },
        // { key: '3', label: '已拒绝' }
        { label: "未查看", key: "0" },
        { label: "已查看", key: "1" },
        { label: "待面试", key: "11" },
        { label: "已拒绝", key: "12" },
        { label: "已结束", key: "13" },
      ],
      tabValue: "1",
      filter: { CONFIRM: ["0"] },
      page: 1,
      total: 0,
      pageSize: 10
    }
  }
  async componentDidMount() {
    this.loadData();
  }

  componentWillUnmount() {

  }

  loadData = () => {
    const { page, pageSize, filter, tabValue } = this.state;
    const onLoadData = (res) => {
      if (res.status == 0) {
        this.setState({ data: res.results, total: res.results.length });
      } else {
        this.setState({ data: [] });
      }
    }
    let url = '/job/interview_list';
    // if (tabValue === '1') url = '/job/application_list';
    WidgetAjax.ajax({ url: path + url, params: { ...filter, page, records: pageSize }, callback: onLoadData });
  }

  onTabChange = async (value) => {
    const { filter } = this.state;
    this.setState({ tabValue: value,data: [] });
    switch (value) {
      // case "1":
      //   await this.setState({ filter: { ...filter, RESULT: ["1"] } });
      //   break;
      // case "2":
      //   await this.setState({ filter: { ...filter, CONFIRM: ["0", "1", "2"] } });
      //   break;
      // case "3":
      //   await this.setState({ filter: { ...filter, CONFIRM: ['6'] } });
      //   break;
      case "0":
        await this.setState({ filter: { CONFIRM: ["0"] } })
        break;
      case "1":
        await this.setState({ filter: { CONFIRM: ["2"] } })
        break;
      case "11":
        await this.setState({ filter: { effective: true, CONFIRM: ["1"] } })
        break;
      case "12":
        await this.setState({ filter: { CONFIRM: ['6', '9'] } })
        break;
      case "13":
        await this.setState({ filter: { effective: false, CONFIRM: ['1', '6', '9'] } })
        break;
      case "14":
        await this.setState({ filter: { effective: false, CONFIRM: ['0', '2'] } })
        break;
    }
    this.loadData();
  }

  onPageChange = async (page, pageSize) => {
    await this.setState({ page, pageSize });
    this.loadData();
  }



  operate = (data) => {
    const { tabValue } = this.state;

    return tabValue === '0' || tabValue === '1' ?
      <><Button onClick={() => { this.interviewConfirm(data, 6) }} style={{ marginRight: "16px" }} type="primary">拒绝</Button>
        <Button onClick={() => { this.interviewConfirm(data, 1) }} type="primary">接受</Button></>
      : null


  }

  interviewConfirm = (data, type) => {
    let params = {
      id: data?.id,
      CONFIRM: type
    }
    const onConfirma = (res) => {
      if (res.status == 0) {
        if (this.props && this.props.onChange) this.props.onChange();
        message.success("操作成功!");

        this.loadData();
      }
    }

    WidgetAjax.ajax({ url: path + '/job/interview_confirm', params, callback: onConfirma });
  }


  render() {
    const { tabsData, tabValue, page, total, pageSize, data } = this.state;


    return <div className='feedback'>
      <div className='feedback_box'>
        <Tabs items={tabsData} value={tabValue} onChange={this.onTabChange} />
      </div>
      <div className='table'>
        <Table data={data} options={{ tips: true, operate: true }} operate={this.operate} history={this.props.history} />
        <div className="cardtable-pagination">
          <Pagination
            hideOnSinglePage={true}
            showQuickJumper
            defaultCurrent={page}
            total={total}
            pageSize={pageSize}
            pageSizeOptions={[10, 20, 50, 100]}
            onChange={this.onPageChange}
          />
        </div>
      </div>


    </div>
  }
}

export default feedback;